import { motion } from "framer-motion";
import { fadeUp } from "@/lib/motion";

export function Reveal({ children, i = 0, className = "", as = "div", testId, ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      data-testid={testId}
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      {...rest}
    >
      {children}
    </Comp>
  );
}

export function Overline({ children, dark = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] font-semibold ${
        dark ? "text-[#0A0A0A]/60" : "text-[#C5A059]"
      } ${className}`}
    >
      <span className={`h-px w-8 ${dark ? "bg-[#0A0A0A]/30" : "bg-[#C5A059]"}`} />
      {children}
    </span>
  );
}
